import { useTranslation } from 'react-i18next'
import Sheet from './Sheet'
import ActionBar from './ActionBar'
import { MenuItem, Select, Typography, FormControl, InputLabel, OutlinedInput, Divider } from '@mui/material';
import InlineLoader from '../loading/InlineLoader';

// A category that has not been chosen yet cannot be represented as '': that is the
// uncategorized scope, and MUI skips onChange when the clicked value equals the current
// one, so the clerk could never pick "Sem categoria"/"No category". A sentinel keeps the
// two apart and gives the closed Select a neutral placeholder to show.
const UNCHOSEN = '__unchosen__';

// The whole store, offered from the scope picker. Widening a run used to mean
// backing out to the mode sheet, which a clerk mid-count has no obvious route
// to -- and "all" is a scope like any other, so it belongs beside the
// categories. A sentinel rather than a real productType, because it is not one.
export const ALL_CATEGORIES = '__all__';

export default function SelectCategory(props) {
    const {
      productType,
      categories = [],
      isLoading,
      location,
      saveCategory,
      showChangeCategory,
      setShowChangeCategory,
    } = props;
    const { t } = useTranslation();

    const countFor = category =>
        location === 'newark' ? category.newarkCount : category.longbranchCount;

    const scannedFor = category =>
        location === 'newark' ? category.newarkScanned : category.longbranchScanned;

    // '' is the uncategorized scope. It needs a visible name or the row reads as blank.
    const labelFor = category =>
        `${category.productType || t('inventoryCheck.noCategory')} (${scannedFor(category) ?? 0}/${countFor(category)})`;

    return (
        <Sheet
            open={showChangeCategory}
            onClose={() => setShowChangeCategory(false)}
            title={t('inventoryCheck.selectCategory.title')}
            actions={<ActionBar cancel={{ label: t('common.cancel'), onClick: () => setShowChangeCategory(false) }} />}
        >
            {isLoading ? (
                <InlineLoader />
            ) : !categories.length ? (
                <Typography textAlign='center'>{t('inventoryCheck.selectCategory.none')}</Typography>
            ) : (
                <FormControl fullWidth variant="outlined">
                    {/* shrink and notched, both explicit: displayEmpty keeps the
                        value area rendered, and without them the outlined label
                        sits in the middle of the field on top of whatever the
                        Select is showing. */}
                    <InputLabel shrink id="category-label">{t('inventoryCheck.selectCategory.label')}</InputLabel>
                    <Select
                        fullWidth
                        id="category"
                        labelId="category-label"
                        value={productType ?? UNCHOSEN}
                        input={<OutlinedInput notched label={t('inventoryCheck.selectCategory.label')} />}
                        onChange={e => saveCategory(e.target.value)}
                        displayEmpty
                    >
                        {productType == null && (
                            <MenuItem value={UNCHOSEN} disabled sx={{ display: 'none' }}>
                                {t('inventoryCheck.selectCategory.placeholder')}
                            </MenuItem>
                        )}
                        <MenuItem value={ALL_CATEGORIES}>
                            {t('inventoryCheck.allCategories')}
                        </MenuItem>
                        <Divider />
                        {categories.map(category => (
                            <MenuItem key={category.productType} value={category.productType}>
                                {labelFor(category)}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>
            )}
        </Sheet>
    )
}
